import { HomeLandingModel } from "./HomeLandingModel";

/**
 * Placeholder landing data for desktop `/home` and `/mobile/home`.
 * Later: replace with data from an API (e.g. `useState` + `fetch` or React Query).
 */
export const defaultHomeLandingModel: HomeLandingModel = {
  heroBgSrc: "",
  heroTextTitle: "Discover & experience stunning XR creations.",
  heroTextSubtitle:
    "Curated home for indie immersive experiences—designed for VisionOS. Browse, explore, and support visionary creators.",
  newestReleasesTitle: "Newest releases",
  newestReleases: [
    {
      id: "release_1",
      title: "Tidefall VR",
      description:
        "Explore the ancient temples of Southeast Asia in an atmospheric 360° journey, guided by local historians and captured in stunning 8K resolution.",
      role: "CREATOR",
      thumbnailSrc: "/images/icons/hero-image.jpg",
      picks: [
        { id: "p1", label: "Category", value: "Adventure" },
        { id: "p2", label: "Format", value: "Passive 360°" },
        { id: "p3", label: "Duration", value: "27 min." },
      ],
    },
    {
      id: "release_2",
      title: "The future that wasn't",
      description:
        "Explore the ancient temples of Southeast Asia in an atmospheric 360° journey, guided by local historians and captured in stunning 8K resolution.",
      price: "Free",
      role: "CREATOR",
      thumbnailSrc: "/images/icons/hero-image.jpg",
      picks: [
        { id: "p1", label: "Category", value: "Sci-fi" },
        { id: "p2", label: "Format", value: "Passive 360°, Spatial Audio" },
        { id: "p3", label: "Duration", value: "12 min." },
      ],
    },
    {
      id: "release_3",
      title: "Oedipus Rex",
      description:
        "Explore the ancient temples of Southeast Asia in an atmospheric 360° journey, guided by local historians and captured in stunning 8K resolution.",
      price: "€3.99",
      role: "CURATOR",
      thumbnailSrc: "/images/icons/hero-image.jpg",
      picks: [
        { id: "p1", label: "Category", value: "Drama" },
        { id: "p2", label: "Format", value: "Immersive theater" },
        { id: "p3", label: "Duration", value: "24 min." },
      ],
    },
    {
      id: "release_4",
      title: "Neon Depths",
      description:
        "A deep-sea odyssey through bioluminescent coral reefs, narrated by marine biologists in breathtaking 8K volumetric capture.",
      price: "€1.99",
      role: "USER",
      thumbnailSrc: "/images/icons/hero-image.jpg",
      picks: [
        { id: "p1", label: "Category", value: "Documentary" },
        { id: "p2", label: "Format", value: "360° Video" },
        { id: "p3", label: "Duration", value: "18 min." },
      ],
    },
  ],
};